import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import axios from 'axios';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

import CallMadeIcon from '@mui/icons-material/CallMade';
import VisibilityIcon from '@mui/icons-material/Visibility';


import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import makeStyles from '@mui/styles/makeStyles';
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';

const drawerWidth = 300;
const materialTheme = createTheme({
    // set default for now
});
const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    yellowButton: {
        backgroundColor: '#ffff00',
        color: 'black',
        '&:hover': {
            backgroundColor: '#ffff00',
        }
    },
    largeIcon: {
        maxWidth: '30px',
        maxHeight: '30px',
        minWidth: '30px',
        minHeight: '30px'
    }
}));
function Notifications(props) {
    const classes = useStyles();

    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        checkNotifications();
    }, [])

    const checkNotifications = async () => {
        const options = {
            method: 'POST',
            url: '/TransactiNotifications/fetchNotifications.json'
        }

        const response = await axios(options)
        const is_success = response.data.response.is_success;
        const fetch_data = response.data.response.data[0];
        const has_email = response.data.response.has_email;

        if (is_success) {
            let notif = {
                'function': fetch_data.name,
                'message': fetch_data.sub_title,
                'link': '/settings',
                'view': 'settings'

            }

            if (!has_email) {
                addNotification(notif);
            }

        }
    }

    const addNotification = (notif) => {
        setNotifications((prevNotifications) => [...prevNotifications, notif]);
    }

    const displayNotifs = () => {
        if (notifications.length === 0) {
            return (
                <Container fixed>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography variant="h6" component="h2" style={{ textAlign: "center" }}>
                                No notifications
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>
            );
        } else {
            return (
                <div>
                    {notifications.map((value, index) => (
                        <ListItem key={index} button divider sx={{ justifyContent: "space-between" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <div>
                                    <Typography variant="h6">{value.function}</Typography>
                                    <Typography variant="body1">{value.message}</Typography>
                                </div>
                                <div>
                                    {value.link && <Link to={{ pathname: "/settings", state: { openDialog: true } }}><NotificationsNoneIcon className={classes.largeIcon} /></Link>}
                                </div>
                            </div>
                        </ListItem>
                    ))}
                </div>
            );
        }
    }

    return (
        <div>
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={props.handleDrawerToggle}
                        className={classes.menuButton}
                        size="large">
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap>
                        Notifications
                    </Typography>
                </Toolbar>
            </AppBar>
            {displayNotifs()}
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}> </ThemeProvider>
            </StyledEngineProvider>
        </div>
    );
}

export default Notifications;